import React, {useState} from "react";
import {makeStyles, withStyles} from "@material-ui/core/styles";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import {useTranslation} from "react-i18next";
import {useRecoilValue} from 'recoil';
import AccountIcon from "../../../assets/icons/AccountIcon";
import NavigateNextSharpIcon from '@material-ui/icons/NavigateNextSharp';
import {activeUser} from '../../../recoil-store/recoil-state';
import {useRecoilActions} from '../../../recoil-store/recoil-actions';
import "./Profile.css";

const StyledMenu = withStyles({
    paper: {
        border: "1px solid #d3d4d5",
    },
})((props) => (
    <Menu
        getContentAnchorEl={null}
        anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
        }}
        transformOrigin={{
            vertical: "top",
            horizontal: "right",
        }}
        {...props}
    />
));

const useStyles = makeStyles({
    borderRadius: {
        borderRadius: "3px",
    },
    text: {
        marginRight: "15px",
        fontWeight: 700,
        fontSize: 12
    },
    menu: {
        paddingTop: 0,
    },
    profileMenu: {
        display: "flex",
        justifyContent: "center",
        marginRight: "20px",
    },
});

const StyledMenuItem = withStyles((theme) => ({
    root: {
        "&:hover": {
            backgroundColor: "#001b2e",
            color: "#fff",
        },
    },
}))(MenuItem);

function Profile({sideBarOpen}) {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);
    const userName = useRecoilValue(activeUser);
    const [rotate, setRotate] = useState(false);
    const actions = useRecoilActions();
    const {t} = useTranslation();

    const showFlags = (event) => {
        setAnchorEl(event.currentTarget);
        setRotate(!rotate);
    };

    const closeFlags = () => {
        setAnchorEl(null);
        setRotate(!rotate);
    };

    const logOutFunc = () => {
        actions.disconnection();
        actions.logout();
    };

    return (
        sideBarOpen ? (
            <div
                className="link cover-list">
                <div
                    className={`account-menu-item expanded hover-me`}>
                    <div className="account-menu-button-group">
                        <div
                            className={`account-menu-button`}
                            aria-controls="customized-menu"
                            aria-haspopup="true"
                        >
                            {userName.substring(0, 2).toUpperCase()}
                        </div>
                        <div className="account-menu-detail">
                            <span className="account-menu-username">{userName}</span>
                            <span className="account-menu-logout"
                                  onClick={logOutFunc}>{t("CONTENT.PROFILE.LOG-OUT")}</span>
                        </div>
                    </div>
                </div>
            </div>
        ) : (
            <div
                className="link cover-list-collapsed">
                <div
                    className={`account-menu-item collapsed`}>
                    <div className="account-menu-button-group">
                        <div
                            className={`account-menu-button`}
                            aria-controls="customized-menu"
                            aria-haspopup="true"
                            onClick={showFlags}
                        >
                            {userName.substring(0, 2).toUpperCase()}
                        </div>
                    </div>
                    <StyledMenu
                        dense="true"
                        id="customized-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={closeFlags}
                        className={classes.profileMenu}
                    >
                        {/* <StyledMenuItem className={classes.menu}>
          <div onClick={() => history("/settings")}>
            <span className={classes.text}>
              {t("CONTENT.PROFILE.SETTINGS")}
            </span>
          </div>
        </StyledMenuItem> */}
                        <StyledMenuItem className={classes.menu} style={{paddingTop: 5}} onClick={logOutFunc}>
                          <span className={classes.text}>
                            {t("CONTENT.PROFILE.LOG-OUT")}
                          </span>
                        </StyledMenuItem>
                    </StyledMenu>
                </div>
            </div>
        )

    );
}

export default Profile;
